module.exports = __webpack_public_path__ + "img/tag_message.fc980b21.png";